/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-return */
import React, { createContext, ReactElement, ReactNode, useContext, useEffect } from 'react';
import { io, Socket } from 'socket.io-client';
import { Transport } from 'engine.io-client';

const socketOptions = {
  transports: ['websocket'],
  path: '/socket.io',
  multiplex: true,
  forceNew: false,
};

export interface SocketIo {
  socketPromise: Socket;
  isConnected: boolean;
  transport: string;
  initialized: boolean;
}

const InitialSocketIo = {
  isConnected: false,
  transport: 'N/A',
} as SocketIo;

const SocketIoContext = createContext<SocketIo>(InitialSocketIo);

interface SocketIoProviderProps {
  children: ReactNode;
}

export default function SocketIoProvider({
  children,
}: SocketIoProviderProps): ReactElement<any, any> {
  const [socketIo, setSocketIo] = React.useState<SocketIo>(InitialSocketIo);

  useEffect(() => {
    console.log('SocketIoProvider mounting');
    const socketIo = initSocket();
    setSocketIo(socketIo as SocketIo);
    return () => {
      console.log('SocketIoProvider unmounting');
    };
  }, []);

  return <SocketIoContext.Provider value={socketIo}> {children} </SocketIoContext.Provider>;
}

function useSocketIo(): SocketIo {
  return useContext(SocketIoContext);
}

function createSocket(): any {
  const ws_url = process.env.REACT_APP_WORKER_URL;
  const socket: Socket = io(ws_url, socketOptions);
  console.log('Socket:', socket);
  // const socket = null;
  return socket;
}

const initSocket = (): SocketIo | null => {
  if (InitialSocketIo.initialized) {
    console.log('Returning cached Socket.io instance');
    return InitialSocketIo;
  }
  InitialSocketIo.socketPromise = createSocket();
  InitialSocketIo.initialized = true;
  console.log('Initializing Socket.io');

  const _socket = InitialSocketIo.socketPromise;
  if (!_socket) {
    console.error('Socket.io not initialized');
    return null;
  }
  const _socketIo = InitialSocketIo;

  if (_socket.connected) {
    console.log('Socket already connected', _socket.id);
    onConnect();
  }

  function onConnect(): void {
    console.log('Socket Connected:', _socket.id);
    console.log('Socket Transport:', _socket.io.engine.transport.name);
    _socketIo.isConnected = true;
    _socketIo.transport = _socket.io.engine.transport.name;

    _socket.io.engine.on('upgrade', (transport: Transport) => {
      _socketIo.transport = transport.name;
      console.log('Socket Transport Upgraded:', transport.name);
    });
  }

  function onDisconnect(): void {
    _socketIo.isConnected = false;
    _socketIo.transport = 'N/A';
    console.log('Socket Disconnected');
  }

  _socket.on('connect', onConnect);
  _socket.on('disconnect', onDisconnect);
  return _socketIo;
};

export { SocketIoProvider, useSocketIo };
